export default function SessionUnavailable({ retry }: { retry: () => void }) {
  return (
    <div className="notice error" role="alert">
      <p>We could not verify your session. Please try again.</p>
      <button className="btn" onClick={retry}>Try again</button>
    </div>
  );
}
